(() => {
  if (window.texKneeInitialized) return;
  window.texKneeInitialized = true;

  function init(root) {
    if (root.dataset.tkReady) return;
    root.dataset.tkReady = 'true';
    const slides = [...root.querySelectorAll('[data-tk-slide]')];
    const thumbs = [...root.querySelectorAll('[data-tk-thumb]')];
    const stage = root.querySelector('[data-tk-stage]');
    const counter = root.querySelector('[data-tk-counter]');
    const quantity = root.querySelector('[data-tk-quantity]');
    const form = root.querySelector('.tk-form');
    const addLabel = form?.dataset.tkAddLabel || '';
    const soldOutLabel = form?.dataset.tkSoldOutLabel || '';
    let active = 0;

    function showSlide(index, revealThumb = true) {
      if (!slides.length) return;
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== active; });
      thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === active)));
      if (counter) counter.textContent = `${active + 1} / ${slides.length}`;
      if (revealThumb && thumbs[active]) {
        const rail = thumbs[active].parentElement;
        const thumb = thumbs[active];
        rail.scrollTo({ left: thumb.offsetLeft - rail.offsetLeft - (rail.clientWidth - thumb.clientWidth) / 2, behavior: 'auto' });
      }
    }

    function updateQuantity(value) {
      const max = Number(quantity.max) || 99;
      const count = Math.max(1, Math.min(max, Math.trunc(Number(value)) || 1));
      quantity.value = count;
      root.querySelectorAll('[data-tk-quantity-step]').forEach(button => {
        button.disabled = Number(button.dataset.tkQuantityStep) < 0 ? count === 1 : count === max;
      });
    }

    function updateVariant(input) {
      root.querySelectorAll('[data-tk-color-name]').forEach(el => { el.textContent = input.dataset.title; });
      root.querySelectorAll('[data-tk-price]').forEach(el => { el.textContent = input.dataset.price; });
      root.querySelectorAll('[data-tk-compare-value]').forEach(el => { el.textContent = input.dataset.compare || ''; });
      root.querySelectorAll('[data-tk-compare], [data-tk-sale-badge]').forEach(el => { el.hidden = !input.dataset.compare; });
      root.querySelectorAll('[data-tk-submit]').forEach(button => {
        button.disabled = input.disabled;
        button.querySelector('[data-tk-submit-label]').textContent = input.disabled ? soldOutLabel : addLabel;
      });
      const stickyImage = root.querySelector('[data-tk-sticky-image]');
      if (stickyImage && input.dataset.imageUrl) {
        stickyImage.removeAttribute('srcset');
        stickyImage.src = input.dataset.imageUrl;
      }
      const index = slides.findIndex(slide => slide.dataset.imageId === input.dataset.imageId);
      if (index >= 0) showSlide(index);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', input.value);
      window.history.replaceState(window.history.state, '', url);
    }

    root.addEventListener('click', event => {
      const thumb = event.target.closest('[data-tk-thumb]');
      if (thumb) showSlide(thumbs.indexOf(thumb));
      if (event.target.closest('[data-tk-next]')) showSlide(active + 1);
      if (event.target.closest('[data-tk-prev]')) showSlide(active - 1);
      const step = event.target.closest('[data-tk-quantity-step]');
      if (step && quantity) updateQuantity(Number(quantity.value) + Number(step.dataset.tkQuantityStep));
    });
    root.addEventListener('change', event => {
      if (event.target.matches('[data-tk-variant]')) updateVariant(event.target);
      if (event.target === quantity) updateQuantity(quantity.value);
    });
    stage?.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        showSlide(active + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    let touchStart;
    stage?.addEventListener('touchstart', event => {
      if (event.touches.length === 1) touchStart = { x: event.touches[0].clientX, y: event.touches[0].clientY };
    }, { passive: true });
    stage?.addEventListener('touchend', event => {
      if (!touchStart) return;
      const dx = event.changedTouches[0].clientX - touchStart.x;
      const dy = event.changedTouches[0].clientY - touchStart.y;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) showSlide(active + (dx < 0 ? 1 : -1));
      touchStart = undefined;
    }, { passive: true });
    if (quantity) updateQuantity(quantity.value);

    const primaryButton = root.querySelector('.tk-form [data-tk-submit]');
    const sticky = root.querySelector('[data-tk-sticky]');
    if (primaryButton && sticky) {
      let frame = 0;
      const updateSticky = () => {
        frame = 0;
        sticky.hidden = primaryButton.getBoundingClientRect().bottom >= 0;
      };
      const scheduleSticky = () => {
        if (!frame) frame = window.requestAnimationFrame(updateSticky);
      };
      // A direct anchor jump can move the button from below to above the
      // viewport without crossing an IntersectionObserver threshold.
      window.addEventListener('scroll', scheduleSticky, { passive: true });
      window.addEventListener('resize', scheduleSticky);
      window.addEventListener('pageshow', scheduleSticky);
      updateSticky();
      root.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => {
        window.removeEventListener('scroll', scheduleSticky);
        window.removeEventListener('resize', scheduleSticky);
        window.removeEventListener('pageshow', scheduleSticky);
        window.cancelAnimationFrame(frame);
      }, { once: true });
    }
  }
  function initialize(scope = document) {
    scope.querySelectorAll('[data-tex-knee]').forEach(init);
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-tex-knee] [data-tk-locale-select]');
    if (select) select.form.submit();
  });
})();
